// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { groupBy, isEmpty, keys } from 'lodash/fp';

// Utils
import { length } from '../../../../../../../common/utils/immutableHelper';

// Constants
import { BOARD_DEFAULT_TITLE } from '../../../../../../../common/boards/boardConstants';

// Styles
import './BoardTitleSummary.scss';

const sortBoardTitles = (boardTitleA, boardTitleB) => {
    if (boardTitleA === BOARD_DEFAULT_TITLE || !boardTitleA) return 1;
    if (boardTitleB === BOARD_DEFAULT_TITLE || !boardTitleB) return -1;

    return boardTitleA.localeCompare(boardTitleB);
};

const TITLE_LIMIT = 3;

class BoardTitleSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowAllTitles: false,
        };
    }

    showAllTitles = (event) => {
        event.stopPropagation();
        event.preventDefault();

        this.setState({ shouldShowAllTitles: true });
    };

    render() {
        const { shouldShowAllTitles } = this.state;
        const { boardTitles } = this.props;

        if (!boardTitles) return null;

        const groupedTitles = groupBy(
            (title) =>
                isEmpty(title) || BOARD_DEFAULT_TITLE.toLowerCase() === title.toLowerCase()
                    ? BOARD_DEFAULT_TITLE
                    : title,
            boardTitles,
        );

        const sortedBoardTitles = keys(groupedTitles).sort(sortBoardTitles);

        const titleCount = sortedBoardTitles.length;
        const hiddenTitles = titleCount - TITLE_LIMIT;
        const hasHiddenTitles = !shouldShowAllTitles && hiddenTitles > 1;

        const displayedTitles = hasHiddenTitles ? sortedBoardTitles.slice(0, TITLE_LIMIT) : sortedBoardTitles;

        return (
            <ul className="BoardTitleSummary">
                {displayedTitles.map((title, index) => (
                    <li key={index} className="title">
                        {title}
                        {length(groupedTitles[title]) > 1 ? (
                            <span className="count">(x{length(groupedTitles[title])})</span>
                        ) : null}
                    </li>
                ))}
                {hasHiddenTitles ? (
                    <li className="title expandable" onClick={this.showAllTitles}>
                        +{hiddenTitles} more
                    </li>
                ) : null}
            </ul>
        );
    }
}

BoardTitleSummary.propTypes = {
    boardTitles: PropTypes.array,
};

export default BoardTitleSummary;
